import './_Contact.scss';

function Contact() {
  return (
    <address className="contact-links">
      <span><a href="mailto:andutandominic@gmail.com">andutandominic@gmail.com</a></span>
      <span><a href="https://www.linkedin.com/in/differed/" rel="noopener noreferrer" target="_blank">LinkedIn</a></span>
      <span><a href="https://github.com/Xin1337" rel="noopener noreferrer" target="_blank">GitHub</a></span>
    </address>
  );
}

export default Contact;
